import React from "react";
import { Badge } from "@/components/ui/badge";

// v3: only five statuses.
const STATUS_LABELS = {
  draft: "Draft",
  in_review: "In review",
  approved: "Approved",
  published: "Published",
  archived: "Archived",
};

const STATUS_STYLES = {
  draft: "bg-[rgba(31,111,139,0.10)] text-foreground border-[rgba(31,111,139,0.22)]",
  in_review: "bg-[rgba(183,121,31,0.18)] text-foreground border-[rgba(183,121,31,0.32)]",
  approved: "bg-[rgba(31,122,90,0.16)] text-foreground border-[rgba(31,122,90,0.30)]",
  published: "bg-[rgba(0,116,255,0.14)] text-foreground border-[rgba(0,116,255,0.30)]",
  archived: "bg-[rgba(27,43,63,0.08)] text-muted-foreground border-border",
};

export const StatusPill = ({ status }) => {
  const label = STATUS_LABELS[status] || status;
  const cls = STATUS_STYLES[status] || "bg-secondary";
  return (
    <Badge data-testid={`status-pill-${status}`} className={`border ${cls} font-normal text-[11px] uppercase tracking-[0.08em] px-2 py-0.5`}>
      {label}
    </Badge>
  );
};

export const V3_STATUSES = Object.keys(STATUS_LABELS);
